import api from './client';

export interface WinbackCandidate {
  customer_id: number;
  name: string;
  email: string | null;
  total_spent: number;
  order_count: number;
  days_since_last_order: number;
}

export interface WinbackRecommendationItem {
  customer_name: string;
  suggested_offer: string;
  email_subject: string;
  email_body: string;
  rationale: string;
  expected_impact: string;
}

export interface CustomerWinbackCampaign {
  id: number;
  lapsed_after_days: number;
  customers_analyzed: number;
  candidates: WinbackCandidate[];
  ai_summary: string | null;
  ai_recommendations: WinbackRecommendationItem[];
  ai_model: string | null;
  cost_usd: number;
  created_at: string | null;
}

export interface GenerateWinbackPayload {
  lapsed_after_days?: number;
}

export const winbackApi = {
  list: (page = 1) =>
    api.get<{ data: CustomerWinbackCampaign[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/winback?page=${page}`
    ),

  generate: (payload: GenerateWinbackPayload = {}) =>
    api.post<{ data: CustomerWinbackCampaign }>('/winback/generate', payload),

  show: (id: number) => api.get<{ data: CustomerWinbackCampaign }>(`/winback/${id}`),

  destroy: (id: number) => api.delete(`/winback/${id}`),
};
